"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PositionedSpinner = exports.Loader = exports.PositionedSpinnerBackground = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var enums_1 = require("../../enums");
var FullScreenWrapper_1 = require("../FullScreenWrapper");
var Spinner_1 = require("../Spinner");
var PositionedSpinnerBackground;
(function (PositionedSpinnerBackground) {
    PositionedSpinnerBackground["PRIMARY"] = "primary";
    PositionedSpinnerBackground["SECONDARY"] = "secondary";
    PositionedSpinnerBackground["TERTIARY"] = "tertiary";
    PositionedSpinnerBackground["TRANSPARENT"] = "transparent";
    PositionedSpinnerBackground["WHITE"] = "white";
})(PositionedSpinnerBackground = exports.PositionedSpinnerBackground || (exports.PositionedSpinnerBackground = {}));
var PositionedSpinner = function (props) {
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "positioned-spinner position-".concat(props.position || enums_1.UiPositions.MIDDLE, " positioned-spinner--").concat(props.background || PositionedSpinnerBackground.TRANSPARENT, " ").concat(props.className || ""), style: props.style }, { children: (0, jsx_runtime_1.jsx)(Spinner_1.Spinner, __assign({}, props.spinnerProps)) })));
};
exports.PositionedSpinner = PositionedSpinner;
function Loader() {
    return ((0, jsx_runtime_1.jsx)(FullScreenWrapper_1.FullScreenWrapper, { children: (0, jsx_runtime_1.jsx)(PositionedSpinner, { position: enums_1.UiPositions.MIDDLE, spinnerProps: { size: enums_1.UiSizes.LG } }) }));
}
exports.Loader = Loader;
